module.exports = __webpack_public_path__ + "static/img/home-banner.f090a920.jpg";